(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["seny-watch-archive"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('seny-watch-filter')) {
  customElements.define('seny-watch-filter', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const cards = [...this.querySelectorAll('[data-availability]')];
      const inputs = [...this.querySelectorAll('input[type="checkbox"]')];
      this.querySelectorAll('[data-count]').forEach(el => {
        el.textContent = '(' + cards.filter(card => card.dataset.availability === el.dataset.count).length + ')';
      });
      const update = () => {
        const selected = inputs.filter(input => input.checked).map(input => input.value);
        let count = 0;
        cards.forEach(card => {
          card.hidden = selected.length > 0 && !selected.includes(card.dataset.availability);
          if (!card.hidden) count++;
        });
        this.querySelector('[data-result-count]').textContent = count;
        this.querySelector('.seny-watch-archive__empty').hidden = count > 0;
      };
      inputs.forEach(input => input.addEventListener('change', update));
      this.querySelector('[data-clear]').addEventListener('click', () => {
        inputs.forEach(input => { input.checked = false; });
        update();
      });
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
